module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_9-cc9c5a2a99a4000aca6ef7edd2f2ea99.png";